import { Currency, CurrencySymbols } from '@websky/core/src/enums';
import { getLocale } from '@websky/core/src/utils';
import { OauthServiceType } from '@websky/graphql';
const isProd = process.env.NODE_ENV === 'production';
const currentLocale = getLocale();
const companyInfo = {
    iataCode: '5G',
    privacyPolicy: null,
    legal: 'https://private.sirena-travel.ru/docs/conditions-rus-eng.pdf',
    exareRulesURL: '',
    exarePrivacyPolicyURL: 'https://private.sirena-travel.ru/docs/conditions-rus-eng.pdf',
    subsidyFaresConditionURL: ''
};
export const promoLoaders = [
    {
        type: null,
        image: `https://cdn.websky.aero/content/5G/images/promoLoader1.jpg`
    }
];
export const i18n = {
    ru: {
        Aeroexpress: {
            'View schedule': 'Расписание'
        },
        CheckoutAdditionalService: {
            total: 'всего'
        },
        Checkout: {
            'I accept the': 'Я ознакомился(-лась) с',
            'terms of tariff': 'условиями тарифа',
            'terms of agreement': 'общими правилами перевозок',
            infoLinksLabel_end: ', и принимаю их'
        },
        AdditionalBaggage: {
            'More bags?': 'Нужен дополнительный багаж?'
        },
        Exchange: {
            'I agree with the': 'Я ознакомился(-лась) с',
            'Privacy Policy': 'общими правилами перевозок',
            'Create request': 'Перейти к оплате'
        },
        Refund: {
            'I agree with the': 'Я ознакомился(-лась) с',
            'Privacy Policy': 'общими правилами перевозок'
        },
        Title: {
            companyName: 'Shirak Avia'
        },
        RetrieveBooking: {
            checkinHint: 'Oнлайн регистрация начинается за 24 часа до вылета и заканчивается за 3 часа до вылета.'
        }
    },
    en: {
        CheckoutAdditionalService: {
            total: 'total'
        },
        IncludedBaggage: {
            'Need to bring sports, music or baby equipments?': 'Need to bring your pet, sports or baby equipments?'
        },
        Exchange: {
            'Privacy Policy': 'general rules of transportation'
        },
        Refund: {
            'Privacy Policy': 'general rules of transportation'
        },
        Title: {
            companyName: 'Shirak Avia'
        },
        RetrieveBooking: {
            checkinHint: 'Online check-in opens 24 hours and closes 3 hours before the scheduled departure.'
        }
    },
    de: {
        Title: {
            companyName: 'Shirak Avia'
        }
    },
    fr: {
        Title: {
            companyName: 'Shirak Avia'
        }
    },
    hy: {
        Exchange: {
            'Privacy Policy': 'փոխադրման ընդհանուր կանոններ'
        },
        Refund: {
            'Privacy Policy': 'փոխադրման ընդհանուր կանոններ'
        },
        Title: {
            companyName: 'Shirak Avia'
        },
        RetrieveBooking: {
            checkinHint: 'Առցանց հաշվառումը սկսվում է թռիչքից 24 ժամ առաջ և ավարտվում է թռիչքից 3 ժամ առաջ։'
        }
    },
    ka: {
        Title: {
            companyName: 'Shirak Avia'
        }
    },
    kk: {
        Title: {
            companyName: 'Shirak Avia'
        }
    },
    zh: {
        Title: {
            companyName: 'Shirak Avia'
        }
    }
};
export const passengersConfig = [
    {
        code: 'ADT',
        isAdult: true,
        defaultCount: 1
    },
    {
        code: 'CLD',
        isAdult: false,
        maxCountWithoutAdult: 4
    },
    {
        code: 'INF',
        isAdult: false
    },
    {
        code: 'INS',
        isAdult: false
    }
];
export const config = {
    global: {
        findOrderURL: `https://shirakavia.am/${currentLocale}/booking#/find/`,
        companyInfo,
        showIsActualizationResultOk: false,
        i18n,
        socialAuthMethods: [
            {
                service: OauthServiceType.Google,
                isAvailable: true
            },
            {
                service: OauthServiceType.Vkontakte,
                isAvailable: true
            }
        ],
        authMethods: {
            phone: false,
            ffp: false
        },
        reserveEngines: {
            siteUrl: `https://shirakavia.am/${currentLocale}`
        }
    },
    Account: {
        engineURL: './booking',
        showUserPhoneInput: false,
        initialStayLoggedIn: true
    },
    Engine: {
        promoLoaders: promoLoaders,
        calendarDaysCount: 7,
        searchFormURL: isProd ? './' : null,
        checkInURL: './check-in',
        checkInEnabled: true,
        showAvailableFaresOnly: true
    },
    SearchForm: {
        payByMiles: false,
        showPricesInDatepicker: true,
        passengersConfig,
        selectableCurrencies: [
            {
                code: Currency.RUB,
                symbol: CurrencySymbols.RUB
            },
            {
                code: Currency.AMD,
                symbol: CurrencySymbols.AMD
            },
            {
                code: Currency.EUR,
                symbol: CurrencySymbols.EUR
            },
            {
                code: Currency.USD,
                symbol: CurrencySymbols.USD
            }
        ]
    },
    FlightStatus: {
        playMarketURL: '',
        appStoreURL: ''
    }
};
